import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  appBarRoot: {
    background: 'rgb(255, 255, 255) none repeat scroll 0% 0%',
    minHeight: '80px'
  },
  toolbarRoot: {
    minHeight: '80px',
    justifyContent: 'space-between'
  },
  enterpriseLogo: {
    height: 40
  }
}))
